import React, { useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import moment from 'moment';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import { OFFER_NOTIFICATION_DEVICE } from '../../../../constants/OfferConst';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { formDataValidate } from '../../../../utils/formUtils';
import { fetchAllOffers } from '../../cmsSlice';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { createOfferNotification } from '../../../../utils/ServicesAPIUtils';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const OfferNotificationCreate = (props) => {
  const { toggleDrawer, hotelId, offerItem } = props;
  const dispatch = useDispatch();
  const [tabValue] = useState(0);
  const [notificationLoader, setNotificationLoader] = useState(false);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    devices: {
      value: '',
      fieldName: 'Device',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
  });
  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      e.preventDefault();
      if (!validate(0)) return false;
      dispatch(stepUpLoaderCount());
      setNotificationLoader(true);
      const payload = {
        hotelId,
        id: offerItem.id,
        notification: {
          name: formData.name.value,
          description: formData.description.value,
          devices: formData.devices.value,
          createdAt: moment().unix(),
        },
      };
      await createOfferNotification(payload, language);
      dispatch(fetchAllOffers(hotelId));
      notificationManager('success', 'Notification created successfully');
      setNotificationLoader(false);
      toggleDrawer('', false, '');
    } catch (e) {
      setNotificationLoader(false);
      return notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Error occurred while creating notification',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-11'>
            <span className='page-title'>Push Notification</span>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h5 className='tab-title'>Details</h5>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={48}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    maxLength={1000}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <h5 className='tab-title mt-3'>Devices</h5>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomMultiSelect
                    item={formData.devices}
                    labelPrefix='Select'
                    options={OFFER_NOTIFICATION_DEVICE}
                    hideNullOption={true}
                    handleInputChange={(e) => {
                      setFormData({ devices: e });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              disabled={notificationLoader}
              variant='contained'
              type='submit'
              color='primary'
              size='large'
            >
              Publish
            </Button>
          </div>
          {notificationLoader && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default OfferNotificationCreate;
